import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"
import { Link } from "@tanstack/react-router"
import { Home, LogIn, LogOut, MapPinCheck, Trees, UserCheck2, UserPlus2 } from "lucide-react"
import { useAuth } from "@/hooks/use-auth"
import { NavMain } from "@/components/navigation/nav-main"
import { NavForms } from "@/components/navigation/nav-forms"
import packageJson from '../../package.json';
import { useNetworkState } from "@uidotdev/usehooks"
import { OfflineIndicator } from "@/components/offline-indicator"
import { useManager } from "tinytick/ui-react"

const data = {
    navMain: [
        {
            name: "Home",
            url: "/",
            icon: Home
        },
        // {
        //     name: "Farmers",
        //     url: "/farmers",
        //     icon: UserCheck2
        // },
    ],
    navForms: [
        {
            name: "Farmer Onboarding",
            url: "/outgrower-farmer-onboarding",
            icon: UserPlus2
        },
        {
            name: "Outgrower Monitoring",
            url: "/outgrower-monitoring-questionnaire",
            icon: MapPinCheck
        }
    ]
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { isAuthenticated, login, user } = useAuth();
    const manager = useManager();

    const networkState = useNetworkState();

    return (
        <Sidebar
            className="top-[--header-height] !h-[calc(100-svh-var(--header-height))]"
            {...props}
        >
            <SidebarHeader>
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton size="lg" asChild>
                            <Link to="/">
                                <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                                    <Trees className="size-4" />
                                </div>
                                <div className="grid flex-1 text-left text-sm leading-tight">
                                    <span className="truncate font-semibold">Shamba ODK</span>
                                    <span className="truncate text-xs">{import.meta.env.VITE_COMPANY_NAME || "Unorthodox Solutions"}</span>
                                </div>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarHeader>
            <SidebarContent>
                <NavMain links={data.navMain} />
                <NavForms links={data.navForms} />
            </SidebarContent>
            <SidebarFooter>
                <div className="mx-auto">
                    <OfflineIndicator />
                </div>
                <div className="flex justify-center items-center gap-2">
                    <span className="text-xs">{user?.name || "Guest"}</span>
                    <Separator orientation="vertical" />
                    <span className="text-xs">{user?.email || "@"}</span>
                </div>
                {isAuthenticated && (
                    <Button onClick={() => manager?.scheduleTaskRun('logout')} disabled={!networkState.online}>
                        Logout <LogOut className="size-4" />
                    </Button>
                )}
                {!isAuthenticated && (
                    <Button onClick={() => login()} disabled={!networkState.online}>
                        <LogIn className="size-4" /> Login
                    </Button>
                )}
                <div className="text-xs text-center text-muted-foreground">
                    v{packageJson.version}
                </div>
            </SidebarFooter>
        </Sidebar>
    )
}
